/* ILC product-page custom behavior
   - Character counter for "special requests" textarea (Task 12)
   - Required name input validation on submit (Task 13)
*/
(function () {
  const section = document.querySelector('main-product, product-info, section.product');
  if (!section) return;

  // Character counter for textareas with data-ilc-char-count
  section.querySelectorAll('[data-ilc-char-count]').forEach(function (ta) {
    const wrap = ta.closest('.ilc-pdp-field');
    if (!wrap) return;
    const counter = wrap.querySelector('[data-ilc-count]');
    if (!counter) return;
    ta.addEventListener('input', function () {
      counter.textContent = ta.value.length;
    });
  });

  // Name input: block submit and show error if empty
  const form = section.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      const nameInput = section.querySelector('[data-ilc-name-input][required]');
      if (nameInput && nameInput.value.trim().length === 0) {
        e.preventDefault();
        const field = nameInput.closest('.ilc-pdp-field');
        if (field) field.classList.add('is-error');
        nameInput.focus();
      }
    });
    // Clear error state when user starts typing
    const nameInput = section.querySelector('[data-ilc-name-input]');
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        const field = nameInput.closest('.ilc-pdp-field');
        if (field) field.classList.remove('is-error');
      });
    }
  }
})();
